import React from "react"
import EngagementOverviewSection from "./EngagementOverviewSection"
import EngagementHeatmapSection from "./EngagementHeatmapSection"

const EngagementActivityPanel = ({ organization, onNavigateTab }) => {
  const orgId = organization?.orgId

  return (
    <div className="space-y-2 md:col-span-4">
      <EngagementOverviewSection orgId={orgId} onNavigateTab={onNavigateTab} showReportLink={false} />
      <EngagementHeatmapSection orgId={orgId} />
    </div>
  )
}

export default EngagementActivityPanel